import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import ArrowBackIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';
import { postFindPassword } from 'src/api/User';
import { useNavbarStore } from 'src/stores/UIStore';
import InputBoxOnChange from 'src/components/inputbox/InputBoxOnChange';

const FindingPasswordPageContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 0px 20px;
    box-sizing: border-box;
    gap:20px;
`
const Title = styled.h1`
  text-align: center;
  font-weight: bold;
  font-size: 18px;
`;
const WelcomeContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    gap: 20px;
`
const NextButton = styled.button<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "gray"
      : "linear-gradient(180deg, #0AB2E4 0%, #06799B 65%, #00607C 100%)"};
  color: white;
  width: 100%;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: 'Pretendard';
`;
const ButtonContainer = styled.div`
  display: flex;
  gap:10px;
  width: 100%;
  flex-direction:column;
`
const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 300px; // 로고의 너비를 200px로 설정합니다.
    height: auto;
  }
`;
const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
const FormFieldLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
  width: 100%;
  color: gray; // 라벨의 색상을 회색으로 설정합니다.
`;
const FormInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
  height: 46px;
`;
const AlertSpan = styled.span<{ $isValid: boolean }>`
  color:${({ $isValid }) => ($isValid ? "#39B95B" : "#FF5A5A")};
  font-size: 14px;
  font-weight:500;
  padding:10px;
`
const WelcomeText = styled.span`
    font-size: 14px;
    font-weight: 400;
    text-align: center;
`
const TextBox = styled.div`
    padding: 30px 71px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    background-color: #F5F5F5;
    font-family: 'Pretendard';
    white-space: nowrap;
    text-align: center;
`
const FindingPasswordPage = () => {
    const [currentPage,setCurrentPage] = useState(0)
    const navigate = useNavigate()
    const [validId,setValidId] = useState(true)
    const [id,setId] = useState('')
    const [validName,setValidName] = useState(true)
    const [name,setName] = useState('')
    const [validEmail,setValidEmail] = useState(true)
    const [email,setEmail] = useState('')
    const setNavField= useNavbarStore((state)=>state.setField)
    const [errorText,setErrorText] = useState('')
        
    useEffect(()=>{
      setNavField('isvisible',false)
        return()=>{
          setNavField('isvisible',true)
        }
    },[])


    const handleId = (e:React.ChangeEvent<HTMLInputElement>)=>{
      setId(e.target.value)
    }

    useEffect(() => {
      const regex = /^[a-z0-9]{5,20}$/
      if (id === '') {
        setValidId(true); // 초기값이나 빈 문자열은 유효한 상태로 처리할 수도 있음
      } else {
        setValidId(regex.test(id));
      }
    }, [id]);

    const handleName = (e:React.ChangeEvent<HTMLInputElement>)=>{
      setName(e.target.value)
    }

    useEffect(() => {
      const regex = /^[가-힣]{2,5}$/
      if (name === '') {
        setValidName(true); // 초기값이나 빈 문자열은 유효한 상태로 처리할 수도 있음
      } else {
        setValidName(regex.test(name));
      }
    }, [name]);

    const handleEmail = (e:React.ChangeEvent<HTMLInputElement>)=>{
      setEmail(e.target.value)
    }

    useEffect(() => {
      const regex = /^[A-Za-z][A-Za-z0-9._%+-]*[A-Za-z0-9]@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      if (name === '') {
        setValidEmail(true); // 초기값이나 빈 문자열은 유효한 상태로 처리할 수도 있음
      } else {
        setValidEmail(regex.test(email));
      }
    }, [email]);

    const handleClick = async (id:string,name:string,email:string)=>{
        const response = await postFindPassword(id,name,email)
        if(response.status==="OK"){
          setCurrentPage(1);
        }
        else{
          if (response.status==="403"){
            setErrorText('* 관리자 승인이 필요한 계정입니다.')
          }
          else{
            setErrorText('* 입력하신 정보와 일치하는 계정이 없습니다.')
          }
          setCurrentPage(2)
        }
    }

    const handleToLogin = ()=>{
      navigate('/');
    }

    const handleToRefind = ()=>{
      setCurrentPage(0)
    }



  return (
    <FindingPasswordPageContainer>
        <HeaderContainer>
            <Title>비밀번호 찾기</Title>
            <ArrowBackIcon sx={{
                    fontSize:24,
                    position: 'absolute',
                    display:'flex',
                    left: 20
                    }}
                    onClick={()=>navigate('/')}/>
        </HeaderContainer>
        <WelcomeContainer>
            {currentPage === 0 && 
            <>
            <FormFieldContainer>
              <FormFieldLabel>*아이디</FormFieldLabel>
              <FormInputContainer>
              <InputBoxOnChange onChange={handleId} value={id}/>
              </FormInputContainer>
              {!validId && <AlertSpan $isValid={false}>영문 소문자, 숫자만 사용한 5~20자여야합니다.</AlertSpan>}
            </FormFieldContainer>
            <FormFieldContainer>
                <FormFieldLabel>*이름</FormFieldLabel>
                <FormInputContainer>
                <InputBoxOnChange onChange={handleName} value={name}/>
                </FormInputContainer>
                {!validName && <AlertSpan $isValid={false}>한글만 사용한 2~5자여야합니다.</AlertSpan>}
            </FormFieldContainer>
            <FormFieldContainer>
                <FormFieldLabel>*등록한 이메일</FormFieldLabel>
                <FormInputContainer>
                <InputBoxOnChange onChange={handleEmail} value={email}/>
                </FormInputContainer>
                {!validEmail && <AlertSpan $isValid={false}>올바른 이메일 형식이 아닙니다.</AlertSpan>}
            </FormFieldContainer>
                <NextButton onClick={()=>handleClick(id,name,email)} disabled={!(name !== '' && id !== '' && email !== '' && validName && validId && validEmail)}>임시 비밀번호 발급</NextButton>
            </>}
            {currentPage === 1 &&
            <>
            <WelcomeText>
                아래 이메일로 임시 비밀번호를 발급했습니다.
            </WelcomeText>
            <TextBox>
                이메일 : {email}
            </TextBox>
            <ButtonContainer>
              <NextButton onClick={handleToLogin}>로그인</NextButton>
            </ButtonContainer>
            </>
            }
            {currentPage === 2 &&
              <>
                <TextBox style={{color:'red', padding:'46px 37px', textAlign:'center'}}>
                  {errorText}
                </TextBox>
                <ButtonContainer>
                  <NextButton onClick={handleToRefind}>비밀번호 다시 찾기</NextButton>
                </ButtonContainer>
              </>
            }
        </WelcomeContainer>
    </FindingPasswordPageContainer>
  )
}

export default FindingPasswordPage